import { Popover } from '@mui/material'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectSelector } from '../../../redux/slices/select'
import { fetchLocales } from '../../../redux/thunks/select'

const langIconUrls = {
  uk: '/img/ua.svg',
  en: '/img/en.svg',
}

const Language = () => {
  const { languages } = useSelector(selectSelector)
  const { i18n } = useTranslation()
  const currentLanguageCode = i18n.language
  const currentLanguage =
    languages.find(
      (lang) => (lang?.code || '').toLowerCase() === currentLanguageCode.toLowerCase(),
    ) || {}
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchLocales())
  }, [dispatch])

  // const [openSwitcher, setOpenSwitcher] = useState(false)
  // const handleSwitcher = () => {
  //   setOpenSwitcher(!openSwitcher)
  // }

  const languageContainerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const openPopover = Boolean(anchorEl)

  const handlePopover = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const changeLang = (lang) => {
    // console.log('changedLang to ' + lang?.code)
    // dispatch(setCurrentLanguage(lang))
    i18n.changeLanguage(lang?.code)
    // dayjs.locale(newLang)
    handleClose()
    // handleSwitcher()
  }

  return (
    <div className="language" ref={languageContainerRef}>
      <div className="current" onClick={handlePopover}>
        <Lang lang={currentLanguage} open={openPopover} />
      </div>

      <Popover
        open={openPopover}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        container={languageContainerRef.current}
        className="language_popover"
      >
        <div className="langs">
          {languages.map((lang) => (
            <Lang key={lang.locale_id} lang={lang} onClick={changeLang} />
          ))}
        </div>
      </Popover>

      {/* <Collapse className="switcher" in={openSwitcher} timeout={30} unmountOnExit>
        <div className="langs">
          <Lang lang="UA" onClick={changeLang} />
          <Lang lang="EN" onClick={changeLang} />
          <Lang lang="FR" onClick={changeLang} />
        </div>
      </Collapse> */}
    </div>
  )
}

export default Language

const Lang = ({ lang, open, onClick = () => {} }) => {
  return (
    <div onClick={() => onClick(lang)} className={classNames('lang', { open })}>
      <img src={langIconUrls?.[lang?.code?.toLowerCase()] || ''} alt="" />
      <span className="title">{lang?.name || ''}</span>
    </div>
  )
}
